export const state = {
  contractor: ''
}

export const getters = {
  contractor: (state) => {
    return state.contractor
  }
}

export const mutations = {
  SET_CONTRACTOR: (state, contractor) => {
    state.contractor = contractor
  }
}
